import { Controller, useFormContext } from "react-hook-form";
import { IQuestionForm, SubquestionForm } from "../../../../QuestionForm/QuestionForm";
import { Autocomplete, Chip, TextField } from "@mui/material";
import React, { useState } from "react";
import { QuestionsApi } from "../../../../../api/questions/QuestionsApi";
import { deserializeQuestions } from "../../../../../mobx/stores/questions/deserializer";
import { useLocation } from "react-router-dom";
import { parse } from "query-string";
import { QuestionQuery } from "../../../../../api/questions/typings";

export default function () {
	const { control } = useFormContext<IQuestionForm | SubquestionForm>();
	const [loading, setLoading] = useState(false);
	const [titles, setTitles] = useState<string[]>([]);
	const location = useLocation();
	const params = parse(location.search) as QuestionQuery;

	const onOpen = async () => {
		setLoading(true);
		const response = await QuestionsApi.getQuestions({
			"fields[questions]": "number",
		});
		const titles = deserializeQuestions(response);
		setTitles(titles.map((x) => String(x.number)));
		setLoading(false);
	};

	return (
		<Controller
			control={control}
			name={"numbers"}
			defaultValue={params["filter[number]"] || []}
			render={({ field: { value, onChange } }) => (
				<Autocomplete
					value={value}
					onChange={(_, value) => onChange(value)}
					multiple
					fullWidth
					onOpen={onOpen}
					loading={loading}
					loadingText={"Загрузка..."}
					noOptionsText={"Нет опций"}
					disableCloseOnSelect
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							margin={"dense"}
							size={"small"}
							label={"Номера"}
							placeholder={"Выберите номер задачи"}
						/>
					)}
					getOptionLabel={(option) => option}
					renderTags={(values, getTagProps) =>
						values.map((value, i) => (
							<Chip
								color={"primary"}
								size={"small"}
								variant={"outlined"}
								label={value}
								{...getTagProps({ index: i })}
							/>
						))
					}
					renderOption={(props, option) => (
						<li {...props} key={option}>
							{option}
						</li>
					)}
					options={titles}
				/>
			)}
		/>
	);
}
